<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Reporte </span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Rep_Usabilidad</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="subtitulos">
          reporte de usabilidad
        </b-col>
      </b-row>
       <div class="mt-2 col-md-12"></div>
  <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(generar)">
          <b-row>
            <b-col>
              <b-row>
                <b-col cols="4">
                  <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de inicio:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha inicio"
                                         :max="new Date()"
                                         @input="fechaMaxima($event)"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

                <b-col cols="4">
                  <validation-provider name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de fin:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha fin"
                                         v-model="filtro.fechaFin"
                                         :max="filtro.fechaInicio.addDays(diasMaximoMes) > new Date() ? new Date(): filtro.fechaInicio.addDays(diasMaximoMes)"
                                         :min="filtro.fechaInicio"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col></b-col>
                <b-col class="text-right">
                  <b-button
                      variant="outline-primary"
                      :disabled="loader"
                      @click="obtenerDatos()"
                  >
                    <span v-if="!loader">Buscar</span>
                    <span v-else>
                  <b-spinner small></b-spinner>
                  Buscando...
                </span>
                  </b-button>
                </b-col>

              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
            <b-col cols="12">
        <download-excel
            v-if="datosTabla.length > 0"
            class="btn btn-primary"
            :data="datosTabla"
            :fields="fieldsExcel"
            name="Reporte de usabilidad.xls"
        >
          Generar Excel
          <em class="fa fa-file-excel-o"></em>
        </download-excel>
      </b-col>
            <b-row>
        <b-col cols="12">
          <b-table
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              responsive
              class="parrafos">
            <template v-slot:cell(precioSinDescuento)="row">
              {{ row.item.precioSinDescuento | monedaEntero }}
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla!==undefined && datosTabla.length === 0" variant="warning" show>No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tabla"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "../../components/Header";
export default {
  components: {
    Header,
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loader: false,
      datosTabla: [],
      fields: [],
      paginaActual: 0,
        filtro: {
        fechaInicio: new Date(),
        fechaFin: null
      },
        diasMaximoMes: null,
          fieldsExcel: {
        "NUMERO DE MEMBRESIA": "numeroMembresia",
        "ID TRATAMIENTO": "idTratamiento",
        "PRECIO DEL TX ($)": "precioSinDescuento",
        "DESCUENTO DEL TX (%)": "descuento"
      },
    };
  },
    mounted() {
    this.fields = [
      {key: "numeroMembresia", label: "NUMERO DE MEMBRESIA ", sortable: true},
      {key: "idTratamiento", label: "ID TRATAMIENTO", sortable: true},
      {key: "precioSinDescuento", label: "PRECIO DEL TX ($)", sortable: true},
      {key: "descuento", label: "DESCUENTO DEL TX (%)", sortable: true}
    ];
   },
  methods: {
   obtenerDatos() {
     let fi = new Date(this.filtro.fechaInicio).addDays(1);
      fi.setHours(0,0,0,0)
      let ff = new Date(this.filtro.fechaFin).addDays(1);
      ff.setHours(23, 59, 59, 999)
      let fechaActual = this.$moment(fi);
      let fechaF = this.$moment(ff);
      let fechaInicial = fechaActual.format("YYYY-MM-DD[T]HH:mm:ssZ");
      let fechaFinal = fechaF.format("YYYY-MM-DD[T]HH:mm:ssZ");
      this.loader = true;
      this.datosTabla = [];
      const filtro = {
        "fechaInicio": fechaInicial,
        "fechaFin": fechaFinal
      };
      this.$http
          .post(this.$api + 'reportes/reporteUsabilidad', filtro)
          .then(respuesta => {
        if (respuesta.data.data) {

          if (respuesta.data.data !== undefined) {
            this.datosTabla = respuesta.data.data;
          }
        }
      }).finally(() => {
        this.loader = false;
        this.paginaActual = 0;
      })

   },
   fechaMaxima(event){
      this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.filtro.fechaInicio = new Date(event);
      this.filtro.fechaFin = null;
      
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
};
</script>

<style>
</style>